// removed by extract-text-webpack-plugin
module.exports = {"NewGame":"NewGame__NewGame__3BLex","ToolTipText":"NewGame__ToolTipText__1mpyV"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/GameMenu/ListElements/NewGame/NewGame.css
// module id = 102
// module chunks = 0